const CHANNEL_THEME = {
  SET_THEME: 'SET_THEME',
  SET_DEFAULT_THEME: 'SET_DEFAULT_THEME',
  SET_HEADER_FONT_LOADED: 'SET_HEADER_FONT_LOADED',
  SET_SUBMENU_FONT_LOADED: 'SET_SUBMENU_FONT_LOADED',
  SET_IS_LOADING: 'SET_IS_LOADING'
}

export default CHANNEL_THEME
